var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteWithWriting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79526 2.55818C4.9201 2.55818 4.21064 3.26763 4.21064 4.14279V18.2223C4.21064 19.0975 4.9201 19.8069 5.79526 19.8069H6.00127C6.49833 19.8069 6.90127 20.2099 6.90127 20.7069C6.90127 21.204 6.49833 21.6069 6.00127 21.6069H5.79526C3.92599 21.6069 2.41064 20.0916 2.41064 18.2223V4.14279C2.41064 2.27352 3.92599 0.758179 5.79526 0.758179H17.3901C19.2594 0.758179 20.7748 2.27352 20.7748 4.1428V5.40115C20.7748 5.8982 20.3718 6.30115 19.8748 6.30115C19.3777 6.30115 18.9748 5.8982 18.9748 5.40115V4.1428C18.9748 3.26764 18.2653 2.55818 17.3901 2.55818H5.79526Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4638 7.73651C19.843 7.35724 20.4579 7.35724 20.8372 7.73651L22.8974 9.7967C23.2767 10.176 23.2767 10.7909 22.8974 11.1702L19.4638 7.73651Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1192 8.08103L22.5529 11.5147L12.5953 21.4723L9.16166 18.0386L19.1192 8.08103Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2462 21.8155L8.8126 18.3818L8.04958 21.0524L9.57568 22.5785L12.2462 21.8155Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43915 23.1889L7.89698 21.5865L9.04156 22.7311L7.43915 23.1889Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8763 15.8988C20.3734 15.8988 20.7763 16.3017 20.7763 16.7988V18.2189C20.7763 20.0882 19.261 21.6035 17.3917 21.6035H15.9728C15.4757 21.6035 15.0728 21.2006 15.0728 20.7035C15.0728 20.2065 15.4757 19.8035 15.9728 19.8035H17.3917C18.2669 19.8035 18.9763 19.0941 18.9763 18.2189V16.7988C18.9763 16.3017 19.3793 15.8988 19.8763 15.8988Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30127 10.7988C6.30127 10.3017 6.70421 9.8988 7.20127 9.8988H13.2013C13.6983 9.8988 14.1013 10.3017 14.1013 10.7988C14.1013 11.2959 13.6983 11.6988 13.2013 11.6988H7.20127C6.70421 11.6988 6.30127 11.2959 6.30127 10.7988Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30127 5.99998C6.30127 5.50292 6.70421 5.09998 7.20127 5.09998H16.2013C16.6983 5.09998 17.1013 5.50292 17.1013 5.99998C17.1013 6.49703 16.6983 6.89998 16.2013 6.89998H7.20127C6.70421 6.89998 6.30127 6.49703 6.30127 5.99998Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.30127 15.6006C6.30127 15.1035 6.70421 14.7006 7.20127 14.7006H8.40127C8.89833 14.7006 9.30127 15.1035 9.30127 15.6006C9.30127 16.0976 8.89833 16.5006 8.40127 16.5006H7.20127C6.70421 16.5006 6.30127 16.0976 6.30127 15.6006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteWithWriting);
export default __webpack_public_path__ + "static/media/noteWithWriting.5a7648a7.svg";
export { ForwardRef as ReactComponent };